import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useTwitchTokenMutation = createMutationHook(
  CreatorIntegrationsApiClient.getTwitchToken,
  {
    mutationKey: ['twitchToken'],
  },
)
